import React from 'react';
import PeopleIcon from '@material-ui/icons/People';
import FancyCard from '../../../components/FancyCard/FancyCard';
import { Link } from 'react-router-dom';
import { getRouteNames } from '../../../routes/routes.data';
import { useStore } from '../../../stores';
import { CircularProgress } from '@material-ui/core';
import { observer } from 'mobx-react';
import AudiotrackIcon from '@material-ui/icons/Audiotrack';

const TracksStats = () => {
    const { tracksStore } = useStore()

    var count = 0
    if (tracksStore.error) {
        count = <span style={{ color: "red" }}>Error</span>;
    } else if (tracksStore.loading) {
        count = <CircularProgress size={15} color="inherit" />;
    } else {
        count = tracksStore?.tracks?.totalDocs || 0;
    }

    return (
        <FancyCard
            cardHeader={
                <FancyCard.CardHeader icon>
                    {(headerClasses) => (
                        <>
                            <FancyCard.CardIcon color="purple">
                                <AudiotrackIcon />
                            </FancyCard.CardIcon>
                            <div style={{ marginTop: 10, textAlign: "right" }}>
                                <p className={headerClasses.cardCategory}>Tracks</p>
                                <h3 className={headerClasses.cardTitle}>
                                    {count}
                                </h3>
                            </div>
                        </>
                    )}
                </FancyCard.CardHeader>
            }
        >
            <FancyCard.CardContent>
                <FancyCard.Divider />
                <Link to={getRouteNames()["tracks"]}>Search new tracks</Link>
            </FancyCard.CardContent>
        </FancyCard>
    )
}

export default observer(TracksStats);
